import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, signal, HostListener} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Absence} from '../models/absence.model';
import {Employee} from '../models/employee.model';
import {SickLeaveService} from '../services/sick-leave.service';
import {isCancelledAbsence, isErrorAbsence} from '../shared/absence-status.util';
import {DatevAuthStatusService} from '../services/datev-auth-status.service';
import {EauRowActionsComponent} from '../shared/eau-row-actions.component';

@Component({
    selector: 'app-employee-sick-leave-modal',
    standalone: true,
    imports: [CommonModule, EauRowActionsComponent],
    templateUrl: './employee-sick-leave-modal.component.html',
    styleUrls: ['./employee-sick-leave-modal.component.css', '../shared/eau-row-actions.css'],
})
export class EmployeeSickLeaveModalComponent implements OnChanges {
    @Input() employee: Employee | null = null;
    @Output() close = new EventEmitter<void>();

    sickLeaves = signal<Absence[]>([]);
    loading = signal<boolean>(false);
    error = signal<string | null>(null);

    constructor(
        private sickLeaveService: SickLeaveService,
        public datevAuthService: DatevAuthStatusService,
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['employee'] && this.employee) {
            this.loadEmployeeSickLeaves();
        }
    }

    private loadEmployeeSickLeaves() {
        if (!this.employee) return;

        const employeeNumber = Number(this.employee.datevEmployeeNumber);
        this.loading.set(true);
        this.error.set(null);
        this.sickLeaves.set([]);

        this.sickLeaveService.getSickLeaves().subscribe({
            next: (absences: Absence[]) => {
                this.sickLeaves.set(absences.filter(a => a.mitarbeiterID === employeeNumber));
                this.loading.set(false);
            },
            error: (error: string) => {
                this.error.set(error);
                this.loading.set(false);
            }
        });
    }

    isCancelled = isCancelledAbsence;
    isError = isErrorAbsence;

    // Lädt die Liste nach einer erfolgreichen Zeilen-Aktion (EauRowActionsComponent) im
    // Hintergrund neu, ohne das globale loading()-Signal zu setzen oder die Liste
    // zwischenzeitlich zu leeren. Ein Fehler hier wird bewusst nicht über error() angezeigt, da
    // das die ganze Tabelle ausblenden würde - die Zeile behält dann einfach ihren zuletzt
    // bekannten Stand.
    refreshEmployeeSickLeavesSilently() {
        if (!this.employee) return;

        const employeeNumber = Number(this.employee.datevEmployeeNumber);
        this.sickLeaveService.getSickLeaves().subscribe({
            next: (absences: Absence[]) => {
                this.sickLeaves.set(absences.filter(a => a.mitarbeiterID === employeeNumber));
            },
            error: () => {
            }
        });
    }

    @HostListener('document:keydown', ['$event'])
    handleKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape' && this.employee) {
            event.stopPropagation();
            this.onClose();
        }
    }

    onClose() {
        this.close.emit();
    }
}
